import $ from 'jquery';
import SwiperCarousel from "./ab-swiper-carousel";

function getOptions(target) {
	let options = {};
	const $_target = $(target);
	//-verifica classe
	if ($_target.hasClass('carousel-pdf')){
		options = {
			navigation: {
				nextEl: $_target.find('.arrow-right')[0],
				prevEl: $_target.find('.arrow-left')[0],
			},
			speed: 800,
		}
	}else if($_target.hasClass('carousel-gallery')){
		options = {
			pagination:{
				el: ".swiper-pagination",
          	type: "fraction",
			},
			navigation: {
				nextEl: $_target.find('.arrow-right')[0],
				prevEl: $_target.find('.arrow-left')[0],
			},
			speed: 800,
		}
	}else if($_target.hasClass('carousel-gallery-card')){
		options = {
			navigation: {
				nextEl: $_target.find('.arrow-right')[0],
				prevEl: $_target.find('.arrow-left')[0],
			},
			speed: 800,
			slidesPerView: 2.5,
			spaceBetween: 15,
			allowTouchMove: false,
			observer: true,
			observeParents: true,
			observeSlideChildren: true
		}
	}else if($_target.hasClass('modal-swiper')){
		options = {
			navigation: {
				nextEl: $_target.find('.arrow-right')[0],
				prevEl: $_target.find('.arrow-left')[0],
			},
			speed: 800,
			slidesPerView: 1,
			spaceBetween: 0,
			allowTouchMove: true,
			loop: true
		}
	}
	//-qui config seguente

	if ($_target.hasClass('no-mobile')) {
		options.disableMobile = true;
	}

	return options;
}

const carousels = $('.swiper-carousel-content');
if (carousels.length > 0){
	carousels.each(function() {
		const swiperC = new SwiperCarousel($(this).find('.swiper-container')[0], getOptions(this));
		swiperC.init();
		//console.log('---', { el: this, container: $(this).find('.swiper-container')[0], swiperC });
	});
}

//brochure ajax modal
$('[data-brochure]').each(function () {
	var id = $(this).attr('data-brochure');
	if (id) $(this).attr('data-bs-toggle', 0);
}); 
$('body').on('click', '[data-brochure]', function (e) {
	var $this = $(this);
	var id = $this.attr('data-brochure');
	if (id) {
		e.preventDefault();
		$this.addClass('loading');
		var title = $this.attr('data-title');
		var blog_id = $this.attr('data-blog');;
		$.ajax({
			url: ajax.url,
			type: 'post',
			data: {
				action: 'ib_populate_modal',
				data: {
				'id': id,
				'title': title,
				'blog_id': blog_id,
				}
			},
			success: function success(obj) {
				$('.modal-container').empty().html(obj);
				var s_carousel = $('.modal-container .swiper-carousel-content');
				var s_options = getOptions(s_carousel);
				var s_swiper = new SwiperCarousel(s_carousel.find('.swiper-container')[0], s_options);
				s_swiper.init();
				$this.removeClass('loading');
				var myModal = $('.modal-container .modal');
				myModal.modal('show');
				$('body').css('overflow', 'hidden');
				$('body').one('click', '.modal-ajax .btn-close', function(){
					myModal.modal('hide');   
					$('body').css('overflow', '');       
				})
			}
		});
	}
});
//piantina ajax modal
$('body').on('click', '[data-piantina]', function (e) {
	var button = $(this);
	var cat = button.attr('data-piantina');
	if (cat) {
		e.preventDefault();
		button.addClass('loading');
		var title = button.attr('data-title');
		var blog_id = button.attr('data-blog');
		$.ajax({
			url: ajax.url,
			type: 'post',
			data: {
				action: 'populate_piantina_viewer',
				data: {
				'cat': cat,
				'title': title,
				'blog_id': blog_id,
				}
			},
			success: function success(obj) {
				$('.modal-container').empty().html(obj);
				var modal = $('.modal-container .modal');
				var s_carousel = modal.find('.swiper-carousel-content');
				var s_options = getOptions(s_carousel);
				var s_swiper = new SwiperCarousel(s_carousel.find('.swiper-container')[0], s_options);
				s_swiper.init();
				button.removeClass('loading');
				modal.modal('show');
				$('body').css('overflow', 'hidden');
				$('body').one('click', '.modal-ajax .btn-close', function(){
					modal.modal('hide');   
					$('body').css('overflow', '');       
				})
			}
		});
	}
});